const MissingRemittanceStatusConstants = Object.freeze([
    {
        label: "Sent to NetRx",
        value: "2423",
    },
    {
        label: "Notice from Net-Rx",
        value: "2424",
    },
    {
        label: "Manually Received",
        value: "2426",
    },
    {
        label: "Sent to Payer",
        value: "2546",
    },
    {
        label: "Automatically Received",
        value: "2554",
    },
    {
        label: "Closed by Net-Rx",
        value: "3348",
    }
]);

export { MissingRemittanceStatusConstants };